import type { AuthError } from "firebase/auth"

export const isAuthError = (subject: unknown): subject is AuthError => {
  if (subject && typeof subject === `object`) {
    const error = subject as Record<string, unknown>

    return (
      typeof error.message === `string` &&
      typeof error.code === `string` &&
      typeof error.customData === `object`
    )
  }

  return false
}
